// import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { texto } from '@/shared';

import {
  CustomAutocomplete,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { ICategoriaIncidentes } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import { useCreateCategoriaIncidentes, useUpdateCategoriaIncidentes } from '@/shared/actions/erp/categoria-incidentes';
import { useFetchDepartamentos } from '@/shared/actions/erp';


const returnUrlCategoryProducto = '/tickets-soporte-cliente/categoria-incidente';

export interface SaveCategoriaIncidenteInterface {
  titlePage: string;
  editCategoriaIncidencia?: ICategoriaIncidentes;
}

type SaveFormData = {
  nombre: string;
  codigo: string;
  estado: boolean;
  descripcion: string;
  departamento: string;
};

const SaveCategoriaIncidente: React.FC<SaveCategoriaIncidenteInterface> = ({
  titlePage,
  editCategoriaIncidencia,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
  //axios
  const { data: dataDepartamento, isLoading: isLoadingDepartamento} = useFetchDepartamentos({
    page_size: 600,
  });
  ///* mutations
  const createCategoryProductMutation = useCreateCategoriaIncidentes({
    navigate,
    returnUrl: returnUrlCategoryProducto
  });
  const updateCategoryProductMutation = useUpdateCategoriaIncidentes({
    navigate,
    returnUrl: returnUrlCategoryProducto
  });


  ///* form
  const form = useForm<SaveFormData>({
    // resolver: yupResolver(newCategoriaIncidenteSchema),
    defaultValues: {
      estado: false,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;



  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editCategoriaIncidencia?.id_categoria_incidencia) {
      return updateCategoryProductMutation.mutate({
        id: editCategoriaIncidencia.id_categoria_incidencia,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createCategoryProductMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editCategoriaIncidencia) {
      setShrink(true);
      reset(editCategoriaIncidencia as any);
    }
  }, [editCategoriaIncidencia]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlCategoryProducto);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        name="codigo"
        label="Codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ""}
        error={errors.codigo}
        helperText={errors.codigo?.message}
        shrink={shrink}
      />
      <CustomTextField
        name="nombre"
        label="Nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ""}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <CustomTextField
        name="descripcion"
        label="Descripción"
        control={form.control}
        defaultValue={form.getValues().descripcion || ""}
        error={errors.descripcion}
        helperText={errors.descripcion?.message}
        shrink={shrink}
      />
      <CustomAutocomplete
        label={texto.departamentos}
        name="departamento"
        options={dataDepartamento?.data.data || []}
        isLoadingData={isLoadingDepartamento}
        defaultValue={form.getValues().departamento || ''}
        valueKey={'nombre'}
        actualValueKey={'codigo'}
        control={form.control}
        error={errors.departamento}
        helperText={errors.departamento?.message}
      />
      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveCategoriaIncidente;
